import React from 'react';
import { Button, Icon } from 'framework7-react';
import II18 from '../../translate/II18';
import PropTypes from 'prop-types';
import ImageViewer from './ImageViewer';
import { mapToArray, onEnterClick } from '../../helpers/utils';
import { SuccessMessageBlock } from '../../requestedDocuments/Elements';
import { DocumentRejectedMessage } from '../../common/DocumentRejectedMessage';

class GalleryContent extends React.Component {
  constructor(props) {
    super(props);
    // noinspection JSUnusedLocalSymbols
    this.state = {
      galleryMode: false,
      currentPage: 0
    };
  }

  showGallery(page) {
    this.setState({
      galleryMode: true,
      currentPage: page
    });
  }

  onImageClick = (index, pageId, submittedPage) => {
    if (this.props.selectMode && !submittedPage) {
      this.props.onSelectItem(pageId);
    } else {
      this.showGallery(index);
    }
  };
  render = () => {
    const {
      images,
      selected,
      selectMode,
      onAddNewItem,
      onDeleteItem,
      onReplaceItem,
      scanEnded,
      showAddImageCard,
      submitted,
      successSentKeys,
      errorSentKeys,
      document,
      xsSizeAtCount,
      xmSizeAtCount,
      submittedDate,
      scannedPages
    } = this.props;

    const { galleryMode, currentPage } = this.state;

    /*
    const restPages = maxPages - images.size;
    const emptyPages =
      restPages > 0
        ? Array.from(new Array(restPages).keys()).map((e, index) => [index, ''])
        : [];
    const images = mapToArray(scannedPages);
    if (restPages > 0) {
      images.push(...emptyPages);
    }
    */
    const imagesUrls = mapToArray(images);
    const submittedPage = pageId => successSentKeys.has(document.id + pageId);
    const problemPage = pageId => errorSentKeys.has(document.id + pageId);

    const readOnly = scanEnded || submitted;
    return (
      <div className={'images-list'}>
        <ImageViewer
          opened={galleryMode}
          pages={imagesUrls}
          startPage={currentPage}
          onClose={() => this.setState({ galleryMode: false })}
        />

        {!galleryMode &&
          (document.rejected ? (
            <DocumentRejectedMessage />
          ) : images.size > 0 ? (
            <ul className="SortableList">
              {Array.from(images).map(([pageId, url], index) => (
                <li
                  tabIndex={0}
                  onClick={() =>
                    this.onImageClick(index, pageId, submittedPage(pageId))
                  }
                  onKeyDown={e => {
                    onEnterClick(e, () =>
                      this.onImageClick(index, pageId, submittedPage(pageId))
                    );
                  }}
                  className={`SortableItem ${selectMode ? 'selectMode' : ''} ${
                    submittedPage(pageId) ? 'readOnly' : ''
                  } ${
                    images.size > (xsSizeAtCount || 10)
                      ? 'xs'
                      : images.size > (xmSizeAtCount || 8)
                      ? 'xm'
                      : ''
                  } ${selected.has(pageId) ? 'selectedItem' : ''} ${
                    problemPage(pageId) || !url ? 'warning' : ''
                  }`}
                  key={index}
                  id={`item-${index}`}
                  data-testid={`galleryImage-${index}`}
                >
                  {!readOnly && !submittedPage(pageId) && (
                    <>
                      <Button
                        className={'replace-page on_hover_title'}
                        onClick={e => {
                          e.stopPropagation();
                          onReplaceItem(pageId);
                        }}
                      >
                        <Icon material="loop" />
                        <span>{II18.get('action_replace')}</span>
                      </Button>
                      <Button
                        className={'delete-page on_hover_title'}
                        onClick={e => {
                          e.stopPropagation();
                          onDeleteItem(pageId);
                        }}
                      >
                        <Icon material="delete_forever" />
                        <span>{II18.get('title_delete')}</span>
                      </Button>
                    </>
                  )}

                  {url && <img alt={`Page ${index}`} src={url} width="100%" />}
                  <label className="pageNumber">{index + 1}</label>
                  <div className="selectedMark">
                    <Icon
                      color="white"
                      size="60"
                      ios="material:done"
                      md="material:done"
                    />
                  </div>
                  <div className="uploadedMark">
                    <Icon
                      color="blue"
                      size="60"
                      ios="material:cloud_done"
                      md="material:cloud_done"
                    />
                  </div>
                  <div className="warningMark">
                    <Icon
                      color="orange"
                      size="60"
                      ios="material:warning"
                      md="material:warning"
                    />
                  </div>
                </li>
              ))}
              {!selectMode && showAddImageCard && !readOnly && (
                <li
                  tabIndex={0}
                  onKeyDown={e => onEnterClick(e, onAddNewItem)}
                  onClick={onAddNewItem}
                  className={`SortableItem addButton  ${
                    images.size > 10 ? 'xs' : images.size > 8 ? 'xm' : ''
                  }`}
                  id={`galleryAddNewPage`}
                >
                  <Icon color="blue" size="60" material="add_to_photos" />
                  <II18 get={'sort_next_x_pages'} />
                </li>
              )}
            </ul>
          ) : document.submitted && scannedPages.size === 0 ? (
            <SuccessMessageBlock submittedDate={submittedDate} oneDocument />
          ) : (
            !readOnly && (
              <div className={'uploader-start-page'}>
                <Icon size={50} color={'blue'} material={'file_upload'} />
                <Button id={'galleryAddNewPage'} fill onClick={onAddNewItem}>
                  <II18>upload_file</II18>
                </Button>
              </div>
            )
          ))}
      </div>
    );
  };
}

GalleryContent.propTypes = {
  selected: PropTypes.object,
  selectMode: PropTypes.bool,
  submitted: PropTypes.bool,
  scanEnded: PropTypes.bool,
  showAddImageCard: PropTypes.bool,
  onSelectItem: PropTypes.func,
  onDeleteItem: PropTypes.func,
  onReplaceItem: PropTypes.func,
  onAddNewItem: PropTypes.func,
  images: PropTypes.object,
  document: PropTypes.object,
  successSentKeys: PropTypes.object,
  errorSentKeys: PropTypes.object,
  xsSizeAtCount: PropTypes.number,
  xmSizeAtCount: PropTypes.number,
  submittedDate: PropTypes.string,
  scannedPages: PropTypes.object
};

export default GalleryContent;
